import { ROUTES } from '@/router/routesEnum';
import { Component, Prop, PropSync, Ref, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Logger } from 'fsts';
import sel, { Selection } from '@/shared/model/selection';
import searchData, { SearchData } from '@/shared/model/smallPayloadModels/searchData';
import DateField from '@/components/_common/date-field/DateField.vue';
import GeneralUtils from '@/shared/utils/generalUtils';

const logger = new Logger('export-list-edit-selection-dialog');
const articleModule = namespace('article');
const modelMarkersModule = namespace('modelMarker');
const colorsModule = namespace('color');
const articleMarkersModule = namespace('articleMarker');
const selectionModule = namespace('selection');

//!! if migration issue check `20221027180447_PX53_add_ArtikelId_field` file

@Component({
  name: 'export-list-edit-selection-dialog',
  components: { DateField },
})
export default class ExportListEditSelectionDialog extends Vue {
  @Ref('productGroupCombobox')
  private refProductGroupCombobox!: any;
  @Ref('suppliersCombobox')
  private refSuppliersCombobox!: any;
  @Ref('warengruppeCombobox')
  private refWarengruppeCombobox!: any;
  @Ref('modelnamesCombobox')
  private refModelNamesCombobox!: any;
  @Ref('articlenamesCombobox')
  private refArticleNamesCombobox!: any;

  @Ref('observer-export-list-edit-selection-dialog-form')
  private observerExportListEditSelectionDialogForm!: any;

  @selectionModule.Action('updateSelection')
  private actionUpdateSelection!: any;
  @selectionModule.Action('addSelectionLog')
  private actionAddSelectionLog!: any;

  @articleModule.Action('updateSearchData')
  private actionUpdateSearchData!: any;
  @articleModule.Getter('getSearchData')
  private getSearchData!: SearchData;
  @articleModule.Action('getArticlesCount')
  private getArticlesCount!: any;

  @modelMarkersModule.Action('getModelMarkers')
  private actionGetModelMarkers!: any;
  @modelMarkersModule.Getter('getModelMarkers')
  private getArticleModelMarkers!: any;

  @colorsModule.Action('getColors')
  private actionGetColors!: any;
  @colorsModule.Getter('getColors')
  private getterColors!: any;

  @Watch('model')
  onModelChanged(newValue: any) {
    console.log('Updated model:', newValue);
    // You can now update the local state with the new model, for example:
    this.searchData = { ...newValue };  // assuming searchData comes from model
  }


  @articleModule.Action('getArticlesProductGroups')
  private actionGetArticlesProductGroups!: any;
  @articleModule.Getter('getArticlesProductGroups')
  private getArticlesProductGroups!: any;

  @articleModule.Action('getArticlesSuppliers')
  private actionGetArticlesSuppliers!: any;
  @articleModule.Getter('getArticlesSuppliers')
  private getArticlesSuppliers!: any;

  @articleModule.Action('getArticlesWarengruppe')
  private actionGetArticlesWarengruppe!: any;
  @articleModule.Getter('getArticlesWarengruppe')
  private getArticlesWarengruppe!: any;

  @articleModule.Action('getArticlesModelNames')
  private actionGetArticlesModelNames!: any;
  @articleModule.Getter('getArticlesModelNames')
  private getArticlesModelNames!: any;

  @articleModule.Action('getArticlesNames')
  private actionGetArticlesNames!: any;
  @articleModule.Getter('getArticlesNames')
  private getArticlesNames!: any;


  @articleMarkersModule.Action('getArticleMarkers')
  private actionGetArticleMarkers!: any;
  @articleMarkersModule.Getter('getArticleMarkers')
  private articleMarkers!: any;



  @Prop({ default: () => ({}) })  // default is an empty object
  private model!: any;

  @Prop({ default: false })
  private dialog!: boolean;

  useCases = [];
  suppliers = [];
  materialGroups = [];
  modelNames = [];
  articleNames = [];
  productGroups = [];
  deltas = [];
  useCasesModels = [];
  data: any = [];
  date: any = '';

  exportName = '';

  get colors() {
    return this.getterColors?.items;
  }



  searchData: any = searchData.defaultData();
  private originalSearchData: any = {};


  private isInitializing = true;
  private ignoreSdWatch = true;
  private sdWatcherChangeAfterInitLoad = false;
  private debouncedGetCount!: () => void;
  @Watch('searchData', { deep: true })
  onSearchDataChanged(newValue: any) {
    console.log('watch Updated searchdata:', newValue, '... isinit ', this.isInitializing);
    // You can now update the local state with the new model, for example:
    // this.searchData = { ...newValue };  // assuming searchData comes from model
    // this.getArticleCount();
    if (this.isInitializing || this.ignoreSdWatch) return;
    this.sdWatcherChangeAfterInitLoad = true;
    this.debouncedGetCount();
  }

  async mounted() {

    this.exportName = this.model.name;

    this.searchData = Object.assign({}, this.getSearchData);
    // this.initForm();
    console.log('this.getSearchData :>> ', this.getSearchData);
    this.isLoadingArticleCount = true;
    var promiseAll = [this.getArticleMarkers(),
    this.getProductGroups(),
    this.getSuppliers(),
    this.getWarengruppe(),
    this.getModelNames(), this.getColors(), this.getModelMarkers()];
    await Promise.all(promiseAll);
    // 2. Initialize the form with the passed model
    this.initForm();


    // Initialize debounce
    this.debouncedGetCount = GeneralUtils.debounce(
      () => this.getArticleCount() // default wait 500 ms
    ) as (() => void) & { cancel: () => void };

    this.getArticleCount();
    // ✅ Initialization complete - enable watch
    this.isInitializing = false;
    this.$nextTick(() => {
      this.ignoreSdWatch = false;
    })
  }

  beforeDestroy() {
    // Clean up debounce to prevent memory leaks
    const debounced = this.debouncedGetCount as (() => void) & { cancel: () => void };
    if (debounced?.cancel) {
      debounced.cancel();
    }
  }


  private get anwendungsszenarienNames() {
    return this.searchData.anwendungsszenarien.map((m: any) => m.name);
  }


  private initForm() {
    console.log('this.model :>> ', this.model);

    // We map the model to searchData. 
    // IMPORTANT: Match the property names to your v-models in the HTML.
    const mappedData = {
      anwendungsszenarien: this.model.articleMarkers || [], //anwendungsszenarien
      // anwendungsszenarien: this.model.articleMarkers?.map((m: any) => m.name) || [],
      produktgruppen: this.model.produktgruppen || [],
      lieferantenNummers: this.model.lieferantenNummers || [],
      warengruppe: this.model.warengruppen || [],
      modelnames: this.model.modelNames || [],
      articlenames: this.model.articleNames || [],
      farbeSuchfarbe: this.model.colors || [], // Based on your previous snippet
      isArticlesWithAllStatuses: this.model.isArticlesWithAllStatuses || false,
      deltaexport: this.model.deltaExport || null,
      preisbindungBis: this.model.preisbindungBis || null,
      lastUpdateOn: this.model.geaendertAm || null,
      erstelltAm: this.model.erstelltAm || null,
      aktionsware: this.model.modelMarkers || []

    };

    // 2. Set the data to searchData
    this.searchData = GeneralUtils.cloneDeep(mappedData);

    // 3. NOW, "Link" the model data to your backend lists
    // This ensures the Autocomplete UI recognizes the items as selected
    //SEEMS TO BE WRONG SHIIT    
    if (this.model.modelMarkers && this.useCasesModels.length > 0) {
      console.log('this.model.modelMarkers :>> ', this.model.modelMarkers);
        this.searchData.aktionsware = this.useCasesModels.filter((uc:any) => 
            this.model.modelMarkers.some((m: any) => m.id === uc.id)
        );
    }

    console.log('this.model.articleMarkers before :>> ', this.model.articleMarkers);

    // Assuming 'articleNames' is the array populated by your getArticleMarkers() call
    if (this.model.articleMarkers && this.model.articleMarkers.length > 0) {
      console.log('this.model.articleMarkers :>> ', this.model.articleMarkers);
      console.log('this.searchData.anwendungsszenarien  :>> ', this.searchData.anwendungsszenarien);
      // this.searchData.anwendungsszenarien = this.useCases.filter((nameObj: any) =>
      //   this.model.articleMarkers.some((m: any) => m.id === nameObj.id)
      // );//.map((m: any) => m.name);

      this.searchData.anwendungsszenarien = this.model.articleMarkers.map((am: any) =>
        this.useCases.find((uc: any) => uc.id === am.id)
      ).filter(Boolean);  // filter out any undefined values
      let result = this.model.articleMarkers.filter((nameObj: any) =>
        this.model.articleMarkers.some((m: any) => m.id === nameObj.id)
      );
      console.log('result :>> ', result);

      console.log('this.searchData.anwendungsszenarien 2  :>> ', this.searchData.anwendungsszenarien);
    }

    this.articleNames = this.model.articleNames || [];
    console.log('this.model.articleNames :>> ', this.model.articleNames);
    if (this.model.articleNames.length > 0) {
      this.searchData.articlenames = this.model.articleNames;
    }


    if (this.model.colors && this.colors.length > 0) {
      this.searchData.farbeSuchfarbe = this.colors.filter((c: any) =>
        this.model.colors.some((mc: any) => mc.id === c.id)
      );
    }

    // ... repeat for other complex object arrays ...

    // 4. Finally, save this "linked" state as the original for change tracking
    this.originalSearchData = GeneralUtils.cloneDeep(this.searchData);

  }


  /**
     * Tracks what changed and returns an audit object
     */
  private getChangedFields() {
    const changes: any = {};

    Object.keys(this.searchData).forEach(key => {
      const oldValue = this.originalSearchData[key];
      const newValue = this.searchData[key];

      if (!GeneralUtils.isEqual(oldValue, newValue)) {
        changes[key] = {
          from: oldValue,
          to: newValue
        };
      }
    });

    return changes;
  }

  private loadOnlyFirstTime = true;
  private previousCountArticle = 0;
  private countArticle = 0;
  private isLoadingArticleCount = false;
  private async getArticleCount() {
    console.log('watch getArticleCount: callj>> ',);
    const payload = GeneralUtils.cloneDeep(this.searchData);
    console.log('payload getArticleCount 1:>> ', payload);
    // Преобразуем массивы объектов в массивы строк/чисел для бэкенда
    payload.anwendungsszenarien = payload.anwendungsszenarien.map((x: any) => x.name || x);
    payload.farbeSuchfarbe = payload.farbeSuchfarbe.map((x: any) => x.name || x);
    payload.aktionsware = payload.aktionsware?.map((x: any) => x.name || x);
    payload.warengruppen = payload.warengruppe?.map((x:any) => x.trim().match(/^\d+/)?.[0]); // select only numbers from `1111 warengruppeName`

    console.log('payload getArticleCount:>> 2 ', payload);


    await this.getArticlesCount({ searchData: payload })
      .then((result: any) => {

        // 👉 only store previous AFTER first successful load
        if (this.loadOnlyFirstTime) {
          this.previousCountArticle = result;
        }
        console.log('wat this.previousCountArticle this.loadOnlyFirstTime :>> ', this.previousCountArticle, '... ', this.loadOnlyFirstTime);

        this.countArticle = result;
        this.loadOnlyFirstTime = false;

        console.log('result getArticleCount:>> ', result);
      })
      .catch((err: any) => {
        logger.error(err);
      })
      .finally(() => {
        this.isLoadingArticleCount = false;
      });
  }


  private loadingSuppliers = false;
  private async getSuppliers() {
    if (this.getArticlesSuppliers?.length > 0) {
      this.suppliers = this.getArticlesSuppliers;
    } else {
      this.loadingSuppliers = true;
      await this.actionGetArticlesSuppliers()
        .then((result: any) => {
          this.suppliers = result;
        })
        .catch((err: any) => {
          logger.error(err);
        })
        .finally(() => {
          this.loadingSuppliers = false;
        });
    }
  }

  private loadingUseCases = false;
  private async getArticleMarkers() {
    if (this.articleMarkers?.length > 0) {
      this.useCases = this.articleMarkers.value;
    } else {
      this.loadingUseCases = true;
      await this.actionGetArticleMarkers()
        .then((result: any) => {
          this.useCases = result.value;
        })
        .catch((err: any) => {
          logger.error(err);
        })
        .finally(() => {
          this.loadingUseCases = false;
        });
    }
  }

  private loadingProductGroups = false;
  private async getProductGroups() {
    if (this.getArticlesProductGroups?.length > 0) {
      this.productGroups = this.getArticlesProductGroups;
    } else {
      this.loadingProductGroups = true;
      await this.actionGetArticlesProductGroups()
        .then((result: any) => {
          this.productGroups = result;
        })
        .catch((err: any) => {
          logger.error(err);
        })
        .finally(() => {
          this.loadingProductGroups = false;
        });
    }
  }

  private loadingWarengruppe = false;
  private async getWarengruppe() {
    if (this.getArticlesWarengruppe?.length > 0) {
      this.materialGroups = this.getArticlesWarengruppe;
    } else {
      this.loadingWarengruppe = true;
      await this.actionGetArticlesWarengruppe()
        .then((result: any) => {
          this.materialGroups = result;
        })
        .catch((err: any) => {
          logger.error(err);
        })
        .finally(() => {
          this.loadingWarengruppe = false;
        });
    }
  }

  private loadingModelNames = false;
  private async getModelNames() {
    if (this.getArticlesModelNames?.length > 0) {
      this.modelNames = this.getArticlesModelNames;
    } else {
      this.loadingModelNames = true;
      await this.actionGetArticlesModelNames()
        .then((result: any) => {
          this.modelNames = result;
        })
        .catch((err: any) => {
          logger.error(err);
        })
        .finally(() => {
          this.loadingModelNames = false;
        });
    }
  }

  private loadingArticlesNames = false;
  private async getArticleNames() {
    if (this.getArticlesNames?.length > 0) {
      this.articleNames = this.getArticlesNames;
    } else {
      this.loadingArticlesNames = true;
      await this.actionGetArticlesNames()
        .then((result: any) => {
          this.articleNames = result;
        })
        .catch((err: any) => {
          logger.error(err);
        })
        .finally(() => {
          this.loadingArticlesNames = false;
        });
    }
  }


  private loadingUseCasesModels = false;
  private async getModelMarkers() {
    if (this.getArticleModelMarkers?.length > 0) {
      this.useCasesModels = this.getArticleModelMarkers;
    } else {
      this.loadingUseCasesModels = true;
      await this.actionGetModelMarkers()
        .then((result: any) => {
          this.useCasesModels = result;
        })
        .catch((err: any) => {
          logger.error(err);
        })
        .finally(() => {
          this.loadingUseCasesModels = false;
        });
    }
  }

  private async getColors() {
    if (this.getterColors?.length > 0) {
      // this.colors = this.colors.value;
    } else {
      await this.actionGetColors()
        .then((result: any) => { })
        .catch((err: any) => {
          logger.error(err);
        });
    }
  }

  isSaving = false;
  async save() {
    this.isSaving = true;
    const payloadSearchData = GeneralUtils.cloneDeep(this.searchData);
    console.log('this.searchData :>> ', this.searchData);
    let payload = { ...this.model, ...payloadSearchData };
    payload.name = this.exportName;

    payload.articleMarkerIds = this.searchData.anwendungsszenarien?.map((c: any) => c.id);
    // payload.modelMarkerIds = this.searchData.anwendungsszenarien?.map((c:any) => c.id);
    payload.modelMarkerIds = this.searchData.aktionsware?.map((c: any) => c.id);
    payload.colorIds = this.searchData.farbeSuchfarbe?.map((c: any) => c.id);
    payload.warengruppen = this.searchData.warengruppe;
    payload.modelNames = this.searchData.modelnames;
    payload.articleNames = this.searchData.articlenames;
    payload.deltaExport = this.searchData.deltaexport;
    payload.geaendertAm = this.searchData.lastUpdateOn;
    console.log('zz payload saved :>> ', payload);
    const result = await this.observerExportListEditSelectionDialogForm.validate();

    const changes = this.getChangedFields();
    const cleanedChanges = GeneralUtils.removeODataType(changes);
    // console.log('zzz changes :>> ',  changes);
    const logPayload = {
      "entityId": this.model.id,
      "changes": cleanedChanges // don't need `stringify` save JSON directly in dtabase `JSONB` field
    };

    console.log('zzzz result :>> ',  result);
    if (result) {
      this.actionUpdateSelection(payload)
        .then((result: any) => {
          this.$emit('update:saved', result.result);

          
          this.actionAddSelectionLog(logPayload).finally(()=> {
            setTimeout(() => {
              this.isSaving = false;
              this.clickClose();
            }, 500);
          });

        })
        .catch((err: any) => {
          logger.error(err);
        }).finally(() => {
            this.isSaving = false;
        });
    } else {
      this.isSaving = false;
    }
 
  }

  //#region Filtering autocomplete data based on previous autocompletes
  private setSearchFormFiltersPayload() {
    let newVal = this.searchData;
    let payload = {
      anwendungsszenarien: newVal.anwendungsszenarien?.map((x: any) => x.name),
      produktgruppen: newVal.produktgruppen,
      warengruppen: newVal.warengruppe,
      lieferantenNummers: newVal.lieferantenNummers,
      modelNames: newVal.modelnames,
      articleNames: newVal.articlenames,
      isArticlesWithAllStatuses: newVal.isArticlesWithAllStatuses,
    };
    return payload;
  }

  showMenu() {
    this.refProductGroupCombobox.activateMenu();
  }

  changeProductGroups() {
    this.refProductGroupCombobox.lazySearch = '';
  }
  changeSupplier() {
    this.refSuppliersCombobox.lazySearch = '';
  }
  changeModelNames() {
    this.refModelNamesCombobox.lazySearch = '';
  }
  changeArticleNames() {
    this.refArticleNamesCombobox.lazySearch = '';
  }


  filterProductGroups() {
    if (this.searchData.anwendungsszenarien?.length > 0) {
      this.loadingProductGroups = true;
      let payload = this.setSearchFormFiltersPayload();

      this.actionGetArticlesProductGroups(payload)
        .then((result: any) => {
          console.log('result :>> ', result);
          this.productGroups = result;
        })
        .catch((err: any) => {
          logger.error(err);
        })
        .finally(() => {
          this.loadingProductGroups = false;
          console.log('productGroupCombobox :>> ', this.refProductGroupCombobox);
          // this.refProductGroupCombobox.activateMenu();

          this.$nextTick(() => {
            this.refProductGroupCombobox.activateMenu();
          });
        });
    }
  }

  filterSupplier() {
    if (this.searchData.anwendungsszenarien?.length > 0 || this.searchData.produktgruppen?.length > 0) {
      this.loadingSuppliers = true;
      let payload = this.setSearchFormFiltersPayload();

      this.actionGetArticlesSuppliers(payload)
        .then((result: any) => {
          this.suppliers = result;
        })
        .catch((err: any) => {
          logger.error(err);
        })
        .finally(() => {
          this.loadingSuppliers = false;

          this.$nextTick(() => {
            this.refSuppliersCombobox.activateMenu();
          });
        });
    }
  }

  filterWarengruppe() {
    if (
      this.searchData.anwendungsszenarien?.length > 0 ||
      this.searchData.produktgruppen?.length > 0 ||
      this.searchData.lieferantenNummers?.length > 0
    ) {
      this.loadingWarengruppe = true;
      let payload = this.setSearchFormFiltersPayload();

      this.actionGetArticlesWarengruppe(payload)
        .then((result: any) => {
          this.materialGroups = result;
        })
        .catch((err: any) => {
          logger.error(err);
        })
        .finally(() => {
          this.loadingWarengruppe = false;

          this.$nextTick(() => {
            this.refWarengruppeCombobox.activateMenu();
          });
        });
    }
  }

  filterModelNames() {
    if (
      this.searchData.anwendungsszenarien?.length > 0 ||
      this.searchData.produktgruppen?.length > 0 ||
      this.searchData.lieferantenNummers?.length > 0 ||
      this.searchData.warengruppe?.length > 0
    ) {
      this.loadingModelNames = true;
      let payload = this.setSearchFormFiltersPayload();

      this.actionGetArticlesModelNames(payload)
        .then((result: any) => {
          this.modelNames = result;
        })
        .catch((err: any) => {
          logger.error(err);
        })
        .finally(() => {
          this.loadingModelNames = false;

          this.$nextTick(() => {
            this.refModelNamesCombobox.activateMenu();
          });
        });
    }
  }

  filterArticleNames() {
    this.loadingArticlesNames = true;
    let payload = this.setSearchFormFiltersPayload();

    this.actionGetArticlesNames(payload)
      .then((result: any) => {
        this.articleNames = result;
      })
      .catch((err: any) => {
        logger.error(err);
      })
      .finally(() => {
        this.loadingArticlesNames = false;

        this.$nextTick(() => {
          this.refArticleNamesCombobox.activateMenu();
        });
      });
  }
  //#endregion



  changeAnderungDate(value: any) {
    this.searchData.lastUpdateOn = value || undefined; // new Date(value).toJSON();
  }
  changeAnlageDate(value: any) {
    this.searchData.erstelltAm = value || undefined; // new Date(value).toJSON();
  }
  changePriceDate(value: any) {
    this.searchData.preisbindungBis = value || undefined; // new Date(value).toJSON();
  }
  changeDeltaDate(value: any) {
    this.searchData.deltaexport = value || undefined; // new Date(value).toJSON();
  }

  clickClose() {
    this.$emit('click:close');
  }

  searchColorInput = '';
  searchModelMakerInput = '';

  searchUseCaseInput = '';
  searchProductInput = '';
  searchSupplierInput = '';
  searchWarengruppeInput = '';
  searchModelNameInput = '';
  searchArticleNameInput = '';

  clearSearchInput() {
    this.searchUseCaseInput = '';
    this.searchProductInput = '';
    this.searchSupplierInput = '';
    this.searchWarengruppeInput = '';
    this.searchModelNameInput = '';
    this.searchArticleNameInput = '';

    this.searchColorInput = '';
    this.searchModelMakerInput = '';
  }
}
